import React from 'react';
import {Col, Row, UiText} from '~/components/elements';
import {PhaseDescription} from '~/types/models/questionnaire';

interface Props {
  phaseDescription: PhaseDescription;
}

const PhaseDescribe = ({phaseDescription}: Props): JSX.Element => {
  return (
    <Col bg="#EEF2DC" w="100%" borderRadius="0.625rem" px={6} py={4} my={2} textAlign="left">
      <UiText fontSize="xs" fontWeight="600" mb={1}>
        {phaseDescription.phaseName}
      </UiText>
      <UiText fontSize="md" fontWeight="bold" mb={4}>
        {phaseDescription.title}
      </UiText>
      <Col>
        {phaseDescription.items?.map((item, index) => (
          <Row key={item.key} textAlign="left" alignItems="center" mb={4}>
            <img src={item.icon} alt={item.key} style={{width: '1.5rem', height: '1.5rem', objectFit: 'contain'}} />
            <UiText fontSize="xs" fontWeight="400" ml={4}>
              {item.description}
            </UiText>
          </Row>
        ))}
      </Col>
      <Row
        bg="white"
        justifyContent="space-between"
        borderRadius="0.625rem"
        border="1px solid #E7EBF1"
        py={2}
        pl={3}
        pr={4}
      >
        <UiText fontSize="sm" fontWeight="600">
          {phaseDescription.payTitle}
        </UiText>
        <Row alignItems="flex-end">
          <UiText fontSize="xs" fontWeight="600">
            {phaseDescription.pricePrefix}&nbsp;
          </UiText>
          <UiText fontSize="md" fontWeight="600" lineHeight="1.25rem">
            {phaseDescription.price}
          </UiText>
          <UiText fontSize="xs" fontWeight="600">
            &nbsp;{phaseDescription.priceSuffix}
          </UiText>
        </Row>
      </Row>
      <Col px={1} mt={2}>
        {phaseDescription.descriptions?.map((description, index) => (
          <UiText key={index} fontSize="0.625rem" fontWeight="400" mt={2}>
            {description}
          </UiText>
        ))}
      </Col>
    </Col>
  );
};

export default PhaseDescribe;
